import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    label: string;
    handleClick: (e: React.MouseEvent) => void;
    disabled?: boolean;
    darkMode?: boolean;
}

const CtiActionButton = ({
    label,
    handleClick,
    disabled,
    darkMode = true,
}: Props) => {
    const borderColor = () => {
        if (disabled) {
            return 'border-gray-500';
        }

        if (darkMode) {
            return 'border-gray-300';
        }

        return 'border-black';
    };

    return (
        <div
            data-test-id={label.replace(/\s/g, '-')}
            className={twMerge(
                'flex h-5 min-w-0 cursor-pointer flex-row items-center justify-center rounded-md border px-3 text-sm font-bold',
                borderColor(),
            )}
            onClick={handleClick}
        >
            <span
                className={twMerge(
                    'overflow-hidden text-ellipsis whitespace-nowrap',
                    darkMode ? 'text-gray-300' : 'text-gray-700',
                )}
            >
                {label}
            </span>
        </div>
    );
};

export default React.memo(CtiActionButton);
